// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/app","css/backend"], () => (__webpack_require__("./resources/assets/js/app.js")))
__webpack_require__.O(undefined, ["css/app","css/backend"], () => (__webpack_require__("./resources/assets/sass/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/app","css/backend"], () => (__webpack_require__("./resources/assets/sass/backend.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
